// Yalnızca ÜRÜN barkodları (1D: EAN-13/8, UPC-A/E, Code128/39, ITF-14) kabul edilir.
// QR / DataMatrix / PDF417 (ambalajdaki web sitesi, kampanya, wifi vb. kodlar) hiçbir okuyucu yolunda işlenmez.
export const PRODUCT_FORMATS = ["ean_13", "ean_8", "upc_a", "upc_e", "code_128", "code_39", "itf"];
const FORMAT_ALIASES = { ean13: "ean_13", ean8: "ean_8", upca: "upc_a", upce: "upc_e", code128: "code_128", code39: "code_39", itf14: "itf", itf: "itf", isbn: "ean_13", databar: "code_128" };
const URLISH = /^(https?:|ftp:|www\.|mailto:|tel:|sms:|smsto:|wifi:|geo:|begin:vcard|mecard:|bitcoin:|whatsapp|instagram\.com|facebook\.com|goo\.gl|bit\.ly)/i;

export const normalizeFormat = (f) => {
  const k = String(f || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  return FORMAT_ALIASES[k] || (PRODUCT_FORMATS.includes(String(f || "").toLowerCase()) ? String(f).toLowerCase() : k);
};

// value: okunan metin · format: okuyucunun bildirdiği biçim (bilinmiyorsa boş) → ürün barkodu mu?
export function isProductBarcode(value, format) {
  const v = String(value || "").trim();
  if (!v) return false;
  if (format) {
    const nf = normalizeFormat(format);
    if (!PRODUCT_FORMATS.includes(nf)) return false;       // qr_code, data_matrix, pdf417, aztec…
  }
  if (URLISH.test(v)) return false;
  if (/[\s/:?#@<>"'{}\\|]/.test(v)) return false;           // URL / metin / boşluk → QR içeriği
  if (v.length < 4 || v.length > 32) return false;
  if (!/^[A-Za-z0-9\-._+$%]+$/.test(v)) return false;
  return true;
}

// Okuyucu sonuç listesinden ilk geçerli ürün barkodunu seç (rawValue/format alanlı nesneler)
export function pickProductCode(codes) {
  for (const c of codes || []) {
    const val = c?.rawValue ?? c?.text ?? "";
    if (isProductBarcode(val, c?.format)) return String(val).trim();
  }
  return "";
}
